import { StepEnum } from './enum/StepEnum';
import { Step } from './types/Step';

/**
 * Defines the order of the stages automatically based on array declaration order
 */
const availableSteps : Step[] = [
  { id: StepEnum.PERSONAL_DATA, title: 'Dados Pessoais'},
  { id: StepEnum.ADDRESS, title:'Endereço'},
  { id: StepEnum.PERSONAL_DOCUMENTS, title: 'Documentos Pessoais'},
  { id: StepEnum.PROFESSIONAL_DOCUMENTS ,title: 'Documentos Profissionais'},
  { id: StepEnum.BANK_DETAILS, title: 'Dados Bancários'},
  { id: StepEnum.DEPENDENTS, title: 'Dependentes'},
  { id: StepEnum.DOCUMENTS_UPLOADS, title: 'Upload Documentos'},
  { id: StepEnum.FINALIZATION_CONFIRMATION, title: 'Finalização'},
  { id: StepEnum.FINALIZATION, title: 'Finalização', hiddenFromStepUI: true},
].map((step,index) => { return {...step, order: index};});

function getFirstStep(): Step {
  return availableSteps[0];
}
function getNextStep(currentStage: Step): Step | null {
  const currentIndex = availableSteps.indexOf(currentStage);
  if (currentIndex >= 0 && currentIndex < availableSteps.length - 1) {
    return availableSteps[currentIndex + 1];
  }
  return null; // Returns null if is in the last stage
}

function getStepByIndex(index:number) : Step | null {
  return availableSteps[index] || null;
}

function getStepById(stepId:string): Step | null {
  return availableSteps.find(step => step.id === stepId) || null;
}

/**
 * Returns the last step of the order, mainly the finalization one, where the process is complete
 */
function getLastStep() : Step {
  return availableSteps.slice(-1)[0];
}

/**
 * Returns step list for the progress bar in the UI
 */
function getStepsForUI() : Step[] {
  return availableSteps.filter(step => !step.hiddenFromStepUI);
}

export default { enum: StepEnum, availableSteps , getNextStep, getFirstStep , getStepsForUI, getLastStep, getStepById, getStepByIndex};